module.exports = __webpack_public_path__ + "img/4备份.f0c2e8be.jpg";